import { Flex } from '@grupoboticario/flora-react';
import { InformationCircleIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';

export const InfoOnboarding = () => {
  return (
    <Flex align='center' gap='$2'>
      <InformationCircleIcon size={16} />
      <ResponsiveFloraTypography fontWeight='medium'>
        Você pode clicar em cada imagem desejada para visualizá-la e baixá-la de forma individual.
      </ResponsiveFloraTypography>
    </Flex>
  );
};
